import { logUsage } from 'owa-analytics';
import { FluidLoadSource, FluidLoadOwaScenario } from './FluidEnums';

export default function fluidComponentLoaded(
    owaScenario: FluidLoadOwaScenario,
    source: FluidLoadSource,
    wasRetry?: boolean
) {
    logUsage('FluidComponentLoaded', {
        OwaScenario_1: owaScenario,
        ComponentSource_2: source,
        WasRetry_3: !!wasRetry,
    });
}
